import { Outlet } from 'react-router-dom';
import DataEditNav from 'components/navs/DataEditNav';

export default function DataEditLayout() {
  return (
    <div>
      <DataEditNav />
      <div className="tabs-wrapper">
        <Outlet />
      </div>
    </div>
  );
}
